import * as React from "react"
import { cmsIntegration as cmsIntegrationText } from "@modules/locales/default.js"
import { CmsOAuthForm } from "./CmsOAuthForm"
import { commonMessageTags, FormattedMessage } from "@modules/locales"
import { CmsVendor } from "@modules/graphql/types"
import { CmsOAuthFormWithFields } from "./CmsOAuthFormWithFields"
import { Spacer } from "gatsby-interface"

export type CmsAuthorizationFormProps = {
  siteId: string
  siteName: string
  cmsVendor: CmsVendor
  cmsVendorName: string
  isProvisioning?: boolean
  onComplete: () => void
  onCancel: () => void
  onAuthorize: () => boolean | void
  origin?: `settings` | `createSite`
}

const VENDORS_WITH_PRE_AUTH_INPUT = [CmsVendor.Cosmicjs, CmsVendor.Shopify]

function vendorRequiresPreAuthInput({ vendor }: { vendor: CmsVendor }) {
  return VENDORS_WITH_PRE_AUTH_INPUT.includes(vendor)
}

export function CmsAuthorizationForm({
  siteId,
  siteName,
  cmsVendor,
  cmsVendorName,
  isProvisioning,
  onCancel,
  onComplete,
  onAuthorize,
  origin,
}: CmsAuthorizationFormProps) {
  return (
    <React.Fragment>
      {isProvisioning ? (
        <FormattedMessage<"siteName" | "cmsVendor", "strong">
          message={cmsIntegrationText.messages.authorizationRequiredToProvision}
          values={{
            siteName,
            cmsVendor: cmsVendorName,
          }}
          tags={commonMessageTags}
        />
      ) : (
        <FormattedMessage<"siteName", "strong">
          message={cmsIntegrationText.messages.authorizationRequired}
          values={{
            siteName,
          }}
          tags={commonMessageTags}
        />
      )}
      <Spacer size={5} />
      {vendorRequiresPreAuthInput({ vendor: cmsVendor }) ? (
        <CmsOAuthFormWithFields
          siteId={siteId}
          cmsVendor={cmsVendor}
          isProvisioning={isProvisioning}
          onComplete={onComplete}
          onCancel={onCancel}
        />
      ) : (
        <CmsOAuthForm
          siteId={siteId}
          cmsVendor={cmsVendor}
          cmsVendorName={cmsVendorName}
          isProvisioning={isProvisioning}
          onCancel={onCancel}
          onAuthorize={onAuthorize}
          origin={origin}
        />
      )}
    </React.Fragment>
  )
}
